import React from "react";
import PropTypes from "prop-types";
import ReactPlayer from "react-player";

class OSSVideoPlayer extends React.Component {
  videoPlayer = null;

  setVideoPlayer = el => {
    this.videoPlayer = el;
  };

  loadVideo = () => {
    const { calculateAspectRatio } = this.props;
    // Check if a player has been loaded by ReactPlayer.
    // Under the hood, this component do a check to see
    // if valid config and url have been passed to props, if not it renders null.
    if (this.videoPlayer && this.videoPlayer.wrapper.childNodes.length) {
      // get the player DOM node
      const player = this.videoPlayer.wrapper.childNodes[0];

      if (!Boolean(calculateAspectRatio)) {
        player.setAttribute("data-height", "352px");
        player.setAttribute("data-width", "625px");
      }

      player.style.textAlign = "center";
    }
  };

  componentDidMount() {
    this.loadVideo();
  }

  componentDidUpdate() {
    this.loadVideo();
  }

  getAspectRatioPadding = () => {
    let aspectRatioPadding = "56.25%"; // 16:9 default.

    if (this.videoPlayer && this.videoPlayer.wrapper.childNodes.length) {
      const player = this.videoPlayer.wrapper.childNodes[0];
      aspectRatioPadding = `${(player.clientHeight / player.clientWidth) *
        100}%`;
    }

    return aspectRatioPadding;
  };

  render() {
    const { calculateAspectRatio, ...rest } = this.props;

    let responsivePlayerWrapperStyles = {
      position: "relative",
      paddingTop: this.getAspectRatioPadding()
    };

    let responsivePlayerStyles = {
      position: "absolute",
      top: 0,
      left: 0
    };

    return (
      <div style={calculateAspectRatio ? responsivePlayerWrapperStyles : null}>
        <ReactPlayer
          ref={this.setVideoPlayer}
          height={calculateAspectRatio ? "100%" : 352}
          style={calculateAspectRatio ? responsivePlayerStyles : null}
          {...rest}
          {...this.state}
        />
      </div>
    );
  }
}

OSSVideoPlayer.propTypes = {
  controls: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  playing: PropTypes.bool,
  url: PropTypes.string,
  config: PropTypes.shape(),
  embed_html: PropTypes.string
};

OSSVideoPlayer.defaultProps = {
  calculateAspectRatio: false,
  controls: true,
  playing: false,
  url: "",
  width: "100%",
  embed_html: "",
  config: {
    youtube: {
      playerVars: {
        showinfo: 1
      }
    },
    facebook: {
      appId: ""
    }
  }
};

export default OSSVideoPlayer;
